// We See You block: eyebrow + headline slide in, then body, then each checklist item staggers in.
document.addEventListener( 'DOMContentLoaded', () => {
	const blocks = Array.from( document.querySelectorAll( '.we-see-you-block' ) );
	if ( ! blocks.length ) return;

	const EASING  = 'cubic-bezier(0.22, 1, 0.36, 1)';
	const DUR     = 0.65;
	const STAGGER = 0.08;
	const OFFSET  = '28px';

	blocks.forEach( ( block ) => {
		const eyebrow    = block.querySelector( '.wsy-eyebrow' );
		const headline   = block.querySelector( 'h2' );
		const bodyText   = block.querySelector( '.wsy-body-text' );
		const listItems  = Array.from( block.querySelectorAll( '.wsy-checklist li' ) );
		const closingEl  = block.querySelector( '.wsy-content > div:last-of-type:not(.wsy-body-text)' );
		const imageCol   = block.querySelector( '.wsy-image-col' );

		// Helper: set initial hidden state
		const hide = ( el, delay = 0 ) => {
			if ( ! el ) return;
			el.style.opacity    = '0';
			el.style.transform  = `translateY( ${ OFFSET } )`;
			el.style.transition = `opacity ${ DUR }s ${ EASING } ${ delay }s, transform ${ DUR }s ${ EASING } ${ delay }s`;
		};

		// Helper: reveal with observer
		const observe = ( el, threshold = 0.25 ) => {
			if ( ! el ) return;
			const obs = new IntersectionObserver( ( entries, observer ) => {
				entries.forEach( ( entry ) => {
					if ( ! entry.isIntersecting ) return;
					entry.target.style.opacity   = '1';
					entry.target.style.transform = 'translateY(0)';
					observer.unobserve( entry.target );
				} );
			}, { threshold } );
			obs.observe( el );
		};

		// Image column slides in from right instead
		if ( imageCol ) {
			imageCol.style.opacity    = '0';
			imageCol.style.transform  = 'translateX(40px)';
			imageCol.style.transition = `opacity ${ DUR }s ${ EASING } 0.15s, transform ${ DUR }s ${ EASING } 0.15s`;
			const imgObs = new IntersectionObserver( ( entries, observer ) => {
				entries.forEach( ( entry ) => {
					if ( ! entry.isIntersecting ) return;
					imageCol.style.opacity   = '1';
					imageCol.style.transform = 'translateX(0)';
					observer.unobserve( entry.target );
				} );
			}, { threshold: 0.15 } );
			imgObs.observe( imageCol );
		}

		hide( eyebrow );
		hide( headline );
		hide( bodyText );
		listItems.forEach( ( item, i ) => hide( item, i * STAGGER ) );
		hide( closingEl );

		observe( eyebrow );
		observe( headline );
		observe( bodyText, 0.15 );
		listItems.forEach( ( item ) => observe( item, 0.15 ) );
		observe( closingEl, 0.15 );
	} );
} );
